import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icons-theme',
  templateUrl: './icons-theme.component.html',
  styleUrls: ['./icons-theme.component.scss']
})
export class IconsThemeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
